import React, {useState} from 'react'
import { useHistory } from 'react-router'
import { followUser } from '../../api/social';
import './index.sass'

import { LazyLoadImage } from 'react-lazy-load-image-component';


export default function Usercard({id, image, username, name, thumb, onFollow }) {
    const history = useHistory();

    const [isFollowed, setIsFollowed] = useState(false);

    const gotoProfile = (e) => {
        history.push({
            pathname: `/user/${username}`
        })    
    }

    const handleFollow = async (e) => {
        e.stopPropagation()
        await followUser(id);
        setIsFollowed(true);
        onFollow()
    }

    return (
        <div className="feed-user-card" onClick={gotoProfile} >
            <div className="feed-user-det">
            <LazyLoadImage alt={image.alt}
                    placeholderSrc={thumb}
                    effect="opacity"
                    threshold={100}
                    height={image.height}
                    src={image}
                    width={image.width} />
                <div>
                    <h5>{name}</h5>
                    <p>@{username}</p>
                </div>
            </div>
            <div onClick={handleFollow} className="feed-follow-button">
                {isFollowed ? 'Followed' : 'Follow'}
            </div>
        </div>
    )
}
